import apiFetch from '../apiFetch'

export default function (token, { page, pageSize, orderBy, number, approvalDateFrom, approvalDateTo, organizedUnit }) {
  const queryParamsArray = [
    page ? `page=${page}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    orderBy ? `orderBy=${orderBy}` : null,
    number ? `number=${number}` : null,
    approvalDateFrom ? `approvalDateFrom=${approvalDateFrom}` : null,
    approvalDateTo ? `approvalDateTo=${approvalDateTo}` : null,
    organizedUnit ? `organizedUnitId=${organizedUnit}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({
    endPoint: `DossierFinder/CampaignExportFinder${queryParams}`,
    method: 'GET',
    body: null,
    token: token
  })
}
